import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject, input } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { FcpMessageService } from '../../services/fcp-message.service';

@Component({
    selector: 'fcp-toast',
    standalone: true,
    imports: [CommonModule, ToastModule],
    styleUrl: './fcp-toast.component.less',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[attr.data-e2e-hook]': 'e2e()'
    },
    template: `
        <p-toast [position]="messageService.position()">
            <ng-template let-message pTemplate="message">
                <div
                    class="fcp-toast-message"
                    [attr.data-action]="!!message.action"
                    [attr.data-dismissible]="message.closable !== false"
                    [attr.data-severity]="message.severity"
                >
                    <div class="fcp-toast-icon">
                        <span [class]="message.icon"></span>
                    </div>
                    <div class="fcp-toast-content">
                        <div class="fcp-toast-title">{{ message.summary }}</div>
                        <div class="fcp-toast-detail fcp-toast-detail-{{ message.severity }}">{{ message.detail }}</div>
                        @if (message.action) {
                            <a
                                [href]="message.action.url"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="fcp-toast-action"
                            >
                                {{ message.action.text }}
                            </a>
                        }
                    </div>
                </div>
            </ng-template>
        </p-toast>
    `
})
export class FcpToastComponent {
    e2e = input<string | null>(null);
    messageService = inject(FcpMessageService);
}
